<mojo-widget [title]="title | async" [showWidgetControls]="true" [widget]="widget" [allowMaximise]="true">
  <ng-container widget-body>
    <mojo-invoice-upload [files]="files | async"
                         (itemClick)="onItemClick($event)"
                         (upload)="onFileUpload($event)"
                         (delete)="onDeleteFile($event)">
    </mojo-invoice-upload>
    <mojo-invoice-input-dialog #invoiceInputDialog
                               [worksAddonEnabled]="worksAddonEnabled"
                               [showAccounts]="showAccounts | async"
                               [availableDocumentTypes]="documentTypes | async"
                               [formDesignId]="formDesignId | async"
                               [accounts]="accounts | async"
                               [vatRates]="vatRates | async"
                               [product]="product | async"
                               (invoiceFormUploaded)="onInvoiceUploaded($event)">
    </mojo-invoice-input-dialog>
  </ng-container>
</mojo-widget>


